import {hexToRgb} from './hexToRgb.js';
import {rgbaToRgb} from './rgbaToRgb.js';

/**
 * Extracts colors from a linear-gradient and returns the most prominent one.
 * @param {string} gradient The gradient string.
 * @return {number[]} The [r, g, b] components of the prominent color.
 */
export function extractColorFromGradient(gradient) {
  const colorRegExp = /(#[0-9a-f]{3,6}|rgba?\([\d\s,.]+\))/gi;
  const colors = gradient.match(colorRegExp);

  if (!colors || colors.length === 0) {
    throw new Error('No colors found in the gradient');
  }

  const rgbColors = colors.map(col => (col.startsWith('#') ? hexToRgb(col) : rgbaToRgb(col)));

  return rgbColors
    .reduce((acc, col) => [acc[0] + col[0], acc[1] + col[1], acc[2] + col[2]], [0, 0, 0])
    .map(val => Math.round(val / rgbColors.length));
}
